import * as React from 'react';
import { Redirect } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import { Theme, makeStyles, useTheme } from '@material-ui/core/styles';
import Paper from '@material-ui/core/Paper';
import Typography from '@material-ui/core/Typography';
import {
  RegisterGrid,
} from './RegisterGrid';
import { VseAlertContainer } from '../alert/VseAlertContainer';
import * as VseAlert from '../../features/alert';
import * as Session from '../../features/session';
import * as SharedData from '../../features/sharedData';
import * as UserRegister from '../../features/account';

const useStyles = makeStyles((theme: Theme) => ({
  root: {
    padding: theme.spacing(2),
  },
  paper: {
    margin: 'auto',
    padding: theme.spacing(2),
  },
}));

export function RegisterPage() {
  const theme = useTheme();
  const classes = useStyles(theme);
  const dispatch = useDispatch();
  const sessionState = Session.useVseSessionState();
  const sharedDataState = SharedData.useVseSharedDataState();
  const userRegisterState = UserRegister.useUserRegisterState();

  React.useEffect(() => {
    return () => {
      dispatch(UserRegister.reset());
      dispatch(VseAlert.dismissValidationProblem());
    }
  }, [dispatch]);

  React.useEffect(() => {
    if (userRegisterState.loading === 'succeeded') {
      dispatch(VseAlert.dismissValidationProblem());
    }
  }, [dispatch, userRegisterState.loading]);

  React.useEffect(() => {
    if (sharedDataState.universityLoading === 'idle') {
      dispatch(SharedData.loadUniversities());
    }
  }, [dispatch, sharedDataState.universityLoading]);

  return (
    sessionState.token.isAuthenticated ? <Redirect to='/apply' /> : (
      <main className={classes.root}>
        <VseAlertContainer />
        <Paper className={classes.paper}>
          {userRegisterState.loading === 'succeeded' ? (
            <div>
              <Typography variant='h6'>Account Creation Successful</Typography>
              <Typography variant='body1'>
                A verification email has been sent to your email address. Click on the link in the email to activate your account.
              </Typography>
            </div>
          ) : (
              <RegisterGrid
                universityOptions={sharedDataState.universityOptions}
                onSubmit={
                  (regForm) => dispatch(UserRegister.register(regForm))
                }
              />
            )
          }
        </Paper>
      </main>
    )
  );
}
